module.exports = __webpack_public_path__ + "img/audio2.1947c07b.svg";